import { TableRes } from '../global'
import request from '../tools/request'
import { getSupplierId } from '../tools/util'
import { HTTP } from './http'
const { GET } = request

// 公告详情
export type ReturnDetail = {
  content: string
  createMan: string
  createTime: number
  id: string
  img: string
  rangType: number
  state: number
  title: string
  codes: string
  sendMsg: boolean
  fileList: string
}

// 获取公告列表
export const GET_NOTICELIST = (param: {
  pageNo: number
  pageSize: number
  rangType: number
  title: string
}) =>
  GET<TableRes<ReturnDetail>>(`${HTTP}/notice/getNoticeList`, {
    ...param,
    supplierId: getSupplierId(),
  })

// 获取公告详情
export const GET_NOTICE_DETAIL = (param: { id: string }) =>
  GET<ReturnDetail>(`${HTTP}/notice/getNoticeDetail`, param)

// 获取最新一条公告
export const GET_LAST_NOTICE = (param: { rangType: number }) =>
  GET<ReturnDetail>(`${HTTP}/notice/getLastNotice`, {
    ...param,
    supplierId: getSupplierId(),
  })
import { TableRes } from '../global'
import request from '../tools/request'
import { getSupplierId } from '../tools/util'
import { HTTP } from './http'
const { GET } = request

// 公告详情
export type ReturnDetail = {
  content: string
  createMan: string
  createTime: number
  id: string
  img: string
  rangType: number
  state: number
  title: string
  codes: string
  sendMsg: boolean
  fileList: string
}

// 获取公告列表
export const GET_NOTICELIST = (param: {
  pageNo: number
  pageSize: number
  rangType: number
  title: string
}) =>
  GET<TableRes<ReturnDetail>>(`${HTTP}/notice/getNoticeList`, {
    ...param,
    supplierId: getSupplierId(),
  })

// 获取公告详情
export const GET_NOTICE_DETAIL = (param: { id: string }) =>
  GET<ReturnDetail>(`${HTTP}/notice/getNoticeDetail`, param)

// 获取最新一条公告
export const GET_LAST_NOTICE = (param: { rangType: number }) =>
  GET<ReturnDetail>(`${HTTP}/notice/getLastNotice`, {
    ...param,
    supplierId: getSupplierId(),
  })
